export default "__VITE_ASSET__BULZGHwM__"